import * as R from "ramda";
import isValid from "utils/value-types/validations/is-valid";
import React from "react";
import FormElements from "components/Global/Modal/Layout/FormElements";
import Helpers from "utils/Global/Helpers";
const { InputSection, InputGroup } = FormElements;
import * as STANDARD_MODULE_FIELD_IDS from "utils/standard-module-field-ids";

export const REQUIRED_FIELDS = ["name", "first_name", "last_name", "email"];
export const SORTED_FIELD_NAMES = [
  "title",
  "company_name",
  "company",
  "email",
  "mobile_phone",
  "home_phone",
  "phone_number",
  "website",
  "about",
  "address",
  "address_line_1",
  "address_line_2",
  "city",
  "address_city",
  "state",
  "state_region",
  "address_state",
  "country",
  "address_country",
  "zip",
  "postal_code",
  "address_zip",
  "linkedin_url",
  "twitter_url",
  "facebook_url"
];

export const sortByInternalName = (firstField, secondField) => {
  if (
    R.prop("internal_name", firstField) > R.prop("internal_name", secondField)
  ) {
    return 1;
  } else if (
    R.prop("internal_name", firstField) < R.prop("internal_name", secondField)
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const validateGenericForm = (
  getFieldsToShow,
  getValuesForSelectedType,
  state
) => {
  if (R.prop("emailError", state).length > 0) {
    return false;
  }
  const requiredFields = getFieldsToShow().filter(
    field =>
      R.prop("isRequired", field) ||
      REQUIRED_FIELDS.includes(R.prop("internal_name", field))
  );

  if (requiredFields.length) {
    for (const field of requiredFields) {
      // Check if the field is an email field - if so, check if the email is valid
      if (
        (field.id === STANDARD_MODULE_FIELD_IDS.CONTACTS.EMAIL ||
          field.type === "email") &&
        state.values[field.id] &&
        state.values[field.id].value
      ) {
        return Helpers.isValidEmail(state.values[field.id].value);
      }

      const isValidValue = isValid(state.values[field.id], field.type);

      if (!isValidValue) {
        return false;
      }
    }
  }

  return true;
};

export const renderSingleGenericField = (
  paramField,
  fields,
  getFieldEditor,
  error
) => {
  const field = REQUIRED_FIELDS.includes(paramField.internal_name)
    ? { ...paramField, isRequired: true }
    : paramField;
  return (
    <InputSection key={field.id}>
      <InputGroup>
        {getFieldEditor({
          field,
          fields,
          error
        })}
      </InputGroup>
    </InputSection>
  );
};

export const renderGenericFields = (fields, renderField) => {
  const hardcodedSortedFields = [];
  const otherFields = [];
  SORTED_FIELD_NAMES.forEach(fieldName => {
    const searchedField = fields.find(
      field => R.prop("internal_name", field) === fieldName
    );
    if (searchedField) {
      hardcodedSortedFields.push(searchedField);
    }
  });
  fields.forEach(field => {
    if (!SORTED_FIELD_NAMES.includes(R.prop("internal_name", field))) {
      otherFields.push(field);
    }
  });
  otherFields.sort(sortByInternalName);
  const sortedFields = [...hardcodedSortedFields, ...otherFields];

  return (
    <div>{sortedFields.map(field => renderField(field, sortedFields))}</div>
  );
};

export const getNonEmptyValues = (values, fieldIds) => {
  return R.compose(
    // filter out empty values
    R.pickBy(val =>
      val && ![undefined, null, false].includes(val?.value)
        ? ["number", "object", "boolean"].includes(typeof val.value)
          ? true
          : val?.value?.length > 0
        : false
    ),
    R.pick(fieldIds)
  )(values);
};
